export class ObjectUtil {
  public static assign(target: Object, source: Object, datesNames?: string[]): void {
    if (source == null) {
      return;
    }
    const objectKeys = Object.keys(source).filter(key => Object.keys(target).includes(key));
    objectKeys.forEach(key => {
      if (datesNames?.includes(key)) {
        target[key] = new Date(source[key]);
      } else {
        target[key] = source[key];
      }

    });
  }
}
